module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-4000-6e8dbb471fc424beba58c887c0025082.jpg";